import vest, { test, enforce } from 'vest';
import any from 'vest/any';
import { CompanyForm, CompanyInfo, IMDBData } from './company.types';
import { uniq } from 'lodash';
const requiredText = enforce.template(enforce.isString().isTruthy());

export const companyValidationSuite = vest.create((company: Partial<CompanyForm> = {}) => {
  test('categories', 'Atleast one company type is required.', () => {
    enforce(company.categories).isTruthy().isNotEmpty();
  });

 /*  test('verified_sections', 'Please lock all the sections to save the deatils', () => {
    
    const associated_person_section = (company.verified_sections != null && company?.verified_sections?.associated_person_section && company?.verified_sections.associated_person_section?.isLockApplied != null) ? (company.verified_sections.associated_person_section.isLockApplied && company.verified_sections.associated_person_section.isLockApplied) : true
    const attribute_section = (company.verified_sections != null && company.verified_sections.attribute_section && company.verified_sections.attribute_section.isLockApplied != null) ? (company.verified_sections.attribute_section.isLockApplied && company.verified_sections.attribute_section.isLockApplied) : true
    const badges_section = (company.verified_sections != null && company.verified_sections.badges_section && company.verified_sections.badges_section.isLockApplied != null) ? (company.verified_sections.badges_section.isLockApplied && company.verified_sections.badges_section.isLockApplied) : true
    const contact_section = (company.verified_sections != null && company.verified_sections.contact_section && company.verified_sections.contact_section.isLockApplied != null) ? (company.verified_sections.contact_section.isLockApplied && company.verified_sections.contact_section.isLockApplied) : true
    const metadata_section = (company.verified_sections != null && company.verified_sections.metadata_section && company.verified_sections.metadata_section.isLockApplied != null) ? (company.verified_sections.metadata_section.isLockApplied && company.verified_sections.metadata_section.isLockApplied) : true
    const profile_section = (company.verified_sections != null && company.verified_sections.profile_section && company.verified_sections.profile_section.isLockApplied != null) ? (company.verified_sections.profile_section.isLockApplied && company.verified_sections.profile_section.isLockApplied) : true
    const services_section = (company.verified_sections != null && company.verified_sections.services_section && company.verified_sections.services_section.isLockApplied != null) ? (company.verified_sections.services_section.isLockApplied && company.verified_sections.services_section.isLockApplied) : true
    const types_section = (company.verified_sections != null && company.verified_sections.types_section && company.verified_sections.types_section.isLockApplied != null) ? (company.verified_sections.types_section.isLockApplied && company.verified_sections.types_section.isLockApplied) : true
    const media_section = (company.verified_sections != null && company.verified_sections.media_section && company.verified_sections.media_section.isLockApplied != null) ? (company.verified_sections.media_section.isLockApplied && company.verified_sections.media_section.isLockApplied) : true
    
    // if(company?.verified_sections == null)
    // && company.verified_sections != null
    if (
      (!associated_person_section || !badges_section || !contact_section || !metadata_section || !attribute_section || !profile_section || !services_section || !media_section || !types_section) 
      ){
        enforce(company.verified_sections).isFalsy();
      }
  }) */
  /* test('verified_sections', 'Please lock all the sections to save the details', () => {
    const sections = company?.verified_sections;

   // console.log('sections', sections);

    enforce(sections).isTruthy();

    if (!sections) return;

    const requiredSections = [
      'associated_person_section',
      'attribute_section',
      'badges_section',
      'contact_section',
      'metadata_section',
      'profile_section',
      'services_section',
      'social_section',
      'types_section',
    ];

    // validate only if section exists
    if (sections.media_section) {
      requiredSections.push('media_section');
    }

    if (sections.policies_section) {
      requiredSections.push('policies_section');
    }

    const isAllLocked = requiredSections.every(sectionKey => {
      return sections?.[sectionKey]?.isLockApplied === true;
    });

   // console.log('requiredSections', requiredSections);
   // console.log('isAllLocked', isAllLocked);

    enforce(isAllLocked).isTruthy();
  }); */
  test('categories', 'Duplicate company types found.', () => {
    if (company.categories) {
      const allIds = company.categories.map(x => x.value);
      const distinctTypes = allIds.filter((x, idx) => allIds.indexOf(x) == idx);
      enforce(allIds.length == distinctTypes.length).isTruthy();
    }
  });
  test('clientServices', 'Duplicate company services found.', () => {
    if (company.clientServices) {
      const allIds = company.clientServices.map(x => x.id);
      const distinctServices = allIds.filter((x, idx) => allIds.indexOf(x) == idx);
      enforce(allIds.length == distinctServices.length).isTruthy();
    }
  });
  test('hqLocation', 'HQ Location is required.', () => {
    enforce(company.hqLocation).isTruthy();
  });
  test('vtr_company_name', 'Company Name is required.', () => {
    enforce(company.vtr_company_name).isTruthy();
  });
  if (company.website) {
    // Bad practive, don't save state.
    test('website', 'Please check if this is a valid url', () => {
      enforce(company.website).matches(
        /(^|\s)((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi
      );
    });
    const imdbProRegEx = '^((http|https)://)?pro.imdb.com/company/';
    const linkedInRegex = '^((http|https)://)?(?:www.)?linkedin.com/';
    const faceBookRegex = '^((http|https)://)?(?:www.)?facebook.com/';
    const wikiRegex = '^((http|https)://)?[a-z]*.wikipedia.org/wiki/';
    const reverseValidation = [
      { regex: imdbProRegEx, message: 'Website cannot be IMDBPro URL' },
      { regex: linkedInRegex, message: 'Website cannot be LinkedIn URL' },
      { regex: faceBookRegex, message: 'Website cannot be Facebook URL' },
      { regex: wikiRegex, message: 'Website cannot be Wiki URL' },
    ];
    for (const urlTest of reverseValidation) {
      if (!companyValidationSuite.get().hasErrors('website')) {
        test('website', urlTest.message, () => {
          enforce(company.website).notMatches(urlTest.regex);
        });
      }
    }
  }
  // test(
  //   'social_imdb_pro_url',
  //   'Not a valid IMDB Pro url, eg: https://pro.imdb.com/company/co0776314/',
  //   () => {
  //     company.social_imdb_pro_url &&
  //       enforce(company.social_imdb_pro_url).matches('^((http|https)://)?pro.imdb.com/company/');
  //   }
  // );
  test(
    'social_linkedin_url',
    'Not a valid LinkedIn url, eg: https://www.linkedin.com/company/warner-bros--entertainment/',
    () => {
      company.social_linkedin_url &&
        enforce(company.social_linkedin_url).matches('^((http|https)://)?(?:www.)?linkedin.com/');
    }
  );
  test(
    'social_facebook_url',
    'Not a valid Facebook url, eg: https://www.facebook.com/pg/Warner-Bros-Entertainment-Benelux',
    () => {
      company.social_facebook_url &&
        enforce(company.social_facebook_url).matches('^((http|https)://)?(?:www.)?facebook.com/');
    }
  );
  test(
    'social_wiki_url',
    'Not a valid Wiki url, eg: https://en.wikipedia.org/wiki/First_National_Pictures',
    () => {
      company.social_wiki_url &&
        enforce(company.social_wiki_url).matches('^((http|https)://)?[a-z]*.wikipedia.org/wiki/');
    }
  );
  test('imdb_company_id', 'Duplicate IMDb id detected', () => {
    const company_imdb_id = company.imdb_company_id;
    // const child_vtr_ids = company.child_vtr_id;
    // const non_child_imdb_ids = (company_imdb_id as unknown as Array<string>).filter(
    //   (x, index) => !(child_vtr_ids as unknown as Array<string>)[index]
    // );
    let duplicate_imdb_id = arr =>
      arr.filter((item, index) => arr.indexOf(item) != index).filter(x => x);
    const duplicate_imdb_ids = duplicate_imdb_id(company_imdb_id);
    enforce(duplicate_imdb_ids.length === 0).isTruthy();
  });
  test('social_urls', 'Duplicate Social URLs detected', () => {
    const social_urls = company.social_urls;
    let duplicate_social_url = arr =>
      arr.filter((item, index) => arr.indexOf(item) != index).filter(x => x);
    const duplicate_social_urls = duplicate_social_url(social_urls);
    enforce(duplicate_social_urls.length === 0).isTruthy();
  });
  test('social_urls_empty', 'One or more Social urls is empty', () => {
    const social_urls = company.social_urls;
    const filtered_social_urls = (social_urls as unknown as Array<string>).filter(
      x => typeof x == 'string'
    );
    const filtered_social_nonepmty_string = filtered_social_urls.filter(x => x);
    enforce(
      filtered_social_nonepmty_string.length === filtered_social_urls.length ||
        filtered_social_urls.length == 1
    ).isTruthy();
  });
  test('imdb_ids_empty', 'One or more IMDb ids is empty', () => {
    const imdb_ids = company.imdb_company_id;
    const child_vtr_ids = company.child_vtr_id;
    const non_child_imdb_ids = (imdb_ids as unknown as Array<string>).filter(
      (x, index) => !(child_vtr_ids as unknown as Array<string>)[index]
    );
    const filtered_imdb_ids = (non_child_imdb_ids as unknown as Array<string>).filter(
      x => typeof x == 'string'
    );
    const filtered_imdb_nonepmty_string = filtered_imdb_ids.filter(x => x);
    enforce(
      filtered_imdb_nonepmty_string.length === filtered_imdb_ids.length ||
        filtered_imdb_ids.length == 1
    ).isTruthy();
  });
});

// const imdb_data=  company.imdb_company_id;
// const company_imdb_id = company.imdb_company_id.filter(x => x)
//     .map(x => (x.imdb_company_id.toLowerCase()))
//     .filter(x => x !== '');
// const company_imdb_name =  company.imdb_company_name.filter(x => x)
//     .map(x => (x.imdb_company_name.toLowerCase()))
//     .filter(x => x !== '');
// const duplicate_imdb_names = duplicate_imdb_id(company_imdb_name);
